import type { MetricDefinition } from "@/features/explorer/types";
import { formatMetricValue as formatExplorerValue } from "./map-utils";

export function formatMetricValue(value: number | null, metric: MetricDefinition): string {
  return formatExplorerValue(value, metric.unit);
}

const PERIOD_PATTERN = /^(?<year>\d{4})-(?<month>\d{2})-(?<day>\d{2})$/;

const MONTH_NAMES = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

/** Turns a "YYYY-MM-DD" period into a friendly label ("2024" or "Mar 2025"). */
export function formatPeriodLabel(period: string): string {
  const match = PERIOD_PATTERN.exec(period);
  if (match?.groups) {
    const { year, month, day } = match.groups;
    if (month === "01" && day === "01") return year;
    return `${MONTH_NAMES[Number(month) - 1]} ${year}`;
  }
  return period;
}
